import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { faCheck, faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Grid from "@mui/material/Grid"
import React, { useState } from "react"
import { Typography, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"

interface SuccessDialogProps {
  title: string
  message?: any
  resetModalState?: (open: boolean) => void
  onAddSubmit?: ((values: any) => void) | null
  values?: any
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  title,
  message,
  resetModalState,
  onAddSubmit = null,
  values = null
}) => {
  const [open, setOpen] = useState(true)
  const theme = useTheme()
  const { t } = useTranslation()

  const handleClose = () => {
    if (onAddSubmit && values) {
      onAddSubmit(values)
      setOpen(false)
      if (resetModalState) resetModalState(false)
      return
    }

    setOpen(false)
    if (resetModalState) resetModalState(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby={title}
      aria-describedby={message}
      maxWidth="xs"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px"
        }
      }}
    >
      <Grid container direction="column" alignItems="center" p={3}>
        <Box bgcolor="success.50" width="1" mb={3} textAlign="center">
          <Grid item>
            <DialogTitle sx={{ p: 0 }} id="alert-dialog-title">
              <Box>
                <FontAwesomeIcon size="3x" icon={faCheckCircle} color={(theme.palette as any).green[900]} />
              </Box>
            </DialogTitle>
          </Grid>
        </Box>

        <DialogContent sx={{ p: 0, mb: 0 }}>
          <Typography sx={{ mb: 1 }} align="center" variant="h4" paragraph>
            {title}
          </Typography>
          {message && (
            <Typography align="center" variant="bodyMedium" color="textSecondary">
              {message}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 0 }}>
          <Box mt={4}>
            <Button onClick={handleClose} color="primary" variant="contained">
              {t("global.ok", "OK")}
            </Button>
          </Box>
        </DialogActions>
      </Grid>
    </Dialog>
  )
}

export default SuccessDialog
